import { useMutation } from 'react-query';
import api from '../../../../libs/api';
import { getApi } from '../../../../config/SwaggerApi';


const addForceSync = () =>  getApi().fastDraftRelaticsSync.fastDraftRelaticsSyncStartFastDraftRelaticsSyncPost();

const useAddForceSync = () => {
    const addForceSyncMutation = useMutation(addForceSync);

    return { addForceSyncMutation };
};

export default useAddForceSync;